module.exports = __webpack_public_path__ + "img/gan.6d284c84.jpeg";